/* eslint-disable react/self-closing-comp */
/* eslint-disable no-shadow */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import axios from "axios";
import dayjs from "dayjs";
import { saveAs } from "file-saver";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditableTable from "components/smea/Table/EditableTable";
import { Close as CloseIcon } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Modal,
  Tooltip,
} from "@mui/material";
import useAxiosPrivate from "contexts/interceptors/axios";
import { useStateContext } from "../../contexts/ContextProvider";

const style = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  position: "absolute",
  backgroundColor: "#e9e9e9",
  boxShadow: "3px 2px 20px 3px rgba(0, 0, 0, 0.4)",
  borderRadius: "10px",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  overflow: "auto",
  "@media (min-width: 10px)": {
    height: "90vh",
    width: "85vw",
  },
  "@media (min-width: 480px)": {
    height: "85vh",
    width: "80vw",
  },
  "@media (min-width: 640px)": {
    height: "75vh",
    width: "70vw",
  },
  "@media (min-width: 768px)": {
    height: "75vh",
    width: "70vw",
  },
  "@media (min-width: 1024px)": {
    height: "80vh",
    width: "70vw",
  },
  "@media (min-width: 1082px)": {
    height: "80vh",
    width: "75vw",
  },
  "@media (min-width: 1440px)": {
    height: "80vh",
    width: "80vw",
  },
  "@media (min-width: 2560px)": {
    height: "70vh",
    width: "60vw", // Adjust this as necessary for large screens
  },
};

export default function SubmissionsModal({ open, handleClose, postId }) {
  const axiosPrivate = useAxiosPrivate();
  const [post, setPost] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const { auth } = useStateContext();

  function getPreviewUrl(FileId) {
    try {
      // Google Drive's preview link format
      const previewUrl = `https://drive.google.com/file/d/${FileId}/preview`;
      return previewUrl;
    } catch (err) {
      console.error("Error generating preview URL:", err);
      throw error;
    }
  }

  const handlePreview = (fileId, title) => {
    if (!fileId) {
      console.error("No file ID provided for preview.");
      return;
    }

    const previewUrl = getPreviewUrl(fileId);
    setPreviewUrl(previewUrl); // Set the preview URL to state
    setPreviewTitle(title); // Set the material title to state
    setPreviewModalOpen(true); // Open the preview modal
  };

  const handleClosePreviewModal = () => {
    setPreviewModalOpen(false); // Close the preview modal
    setPreviewUrl(""); // Clear the preview URL
    setPreviewTitle(""); // Clear material title
  };

  const columnsByPost = [
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      renderCell: (params) => {
        const { FileId, FileName } = params.row;

        return (
          <Box sx={{ display: "flex", gap: 1 }}>
            <Tooltip title={FileName ? "View File" : "No File Available"}>
              <span>
                <IconButton
                  disabled={!FileName}
                  sx={{ color: FileName ? "#1976d2" : "grey" }}
                  onClick={() => handlePreview(FileId, FileName)}
                >
                  <VisibilityIcon />
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      width: 150,
    },
    {
      field: "remarks",
      headerName: "Remarks",
      width: 150,
    },
    {
      field: "submission_status",
      headerName: "Submit Status",

      width: 150,
    },
    {
      field: "postTitle",
      headerName: "Post Title",
      width: 150,
      valueGetter: (params) => params.row?.postTitle?.postTitle,
    },
    {
      field: "officeName",
      headerName: "Office",
      width: 150,
    },
    {
      field: "submitted_by",
      headerName: "Submitted By",

      width: 150,
    },
    {
      field: "designation",
      headerName: "Designation",
      width: 150,
    },
    {
      field: "date_submitted",
      headerName: "Date Submitted",
      width: 200,
      valueGetter: (params) => dayjs(params.value).format("YYYY-MM-DD hh:mm A"),
    },
    {
      field: "FileName",
      headerName: "File Name",
      width: 300,
    },
    {
      field: "FileSize",
      headerName: "File Size",
      width: 130,
    },
    {
      field: "days_early",
      headerName: "Timestamp (Early)",
      width: 200,
    },
    {
      field: "days_late",
      headerName: "Timestamp (Late)",
      width: 200,
    },
    {
      field: "postedBy",
      headerName: "Created By",
      width: 130,
      valueGetter: (params) => params.row?.postTitle?.postedBy,
    },
  ];

  useEffect(() => {
    if (postId && open) {
      setLoading(true);

      axiosPrivate
        .get(`/I-Abide/getAllSubmissionsByPost/${postId}`)
        .then((res) => {
          const submissions = res?.data
            ?.map((item) => item?.Submissions)
            .flat();
          setPost(submissions || []);
        })
        .catch((err) => {
          setError("Error fetching submissions details");
          console.error(err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [postId, open]);

  const handleExport = async () => {
    setLoading(true);
    setError("");

    axiosPrivate
      .get(`/I-ABIDE/filteredReport/exportExcel/${postId}`, {
        responseType: "arraybuffer", // Specify response type as arraybuffer
      })
      .then((res) => {
        const datestamp = dayjs().format("YYYYMMDD");

        // Check if headers exist and handle accordingly
        const contentType =
          res.headers && res.headers["content-type"]
            ? res.headers["content-type"]
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"; // Fallback content type

        // Create a blob from the response data
        const blob = new Blob([res.data], { type: contentType });

        // Create a temporary URL for the blob
        const url = window.URL.createObjectURL(blob);

        // Create a link element and click it to trigger the download
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `I-ABIDE_Report_${datestamp}.xlsx`);
        document.body.appendChild(link);
        link.click();

        // Clean up
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        setError(err?.message || "Error exporting report. Please try again.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleBulkDownloads = async () => {
    setLoading(true);
    setError("");

    // axiosPrivate
    //   .post(`/I-Abide/bulkDownload/${postId}`, null, {
    //     responseType: "blob", // Expect a binary response (ZIP file)
    //   })

    // const BASE_URL = "http://localhost:9000";
    const BASE_URL = "https://smea.depedimuscity.com:8020";

    axios
      .post(`${BASE_URL}/I-Abide/bulkDownload/${postId}`, null, {
        responseType: "blob", // Expect a binary response (ZIP file)
      })
      .then((response) => {
        // Handle the ZIP file response
        const blob = response.data;
        const fileName = `bulk_download_${postId}.zip`; // You can adjust the file name as needed
        saveAs(blob, fileName); // Trigger file download
      })
      .catch((error) => {
        console.error("Error downloading bulk files:", error);
        alert("An error occurred while downloading the files.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        handleClose();
        // formik.resetForm();
        // setError("");
      }}
    >
      <Box sx={style}>
        <Box sx={{ my: 2 }}>
          <Divider
            sx={{ mt: 2, mb: 3, fontWeight: "bold", fontFamily: "Poppins" }}
          >
            SUBMISSIONS
          </Divider>
          {error}
          <Box sx={{ mx: 2 }}>
            <EditableTable
              data={post.length ? post : []}
              columns={columnsByPost}
              loadingState={loading}
              height="60vh"
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "right",
              mt: 2.5,
              mr: 2.5,
              gap: 2,
            }}
          >
            <Button
              onClick={handleBulkDownloads}
              sx={{
                background: "blue",
                color: "white",
                fontSize: "14px",
                fontWeight: "bold",
                padding: "10px 20px",
                // mr: 4,
                borderRadius: "5px",
                boxShadow: "1px 1px 5px rgba(0, 0, 0, 0.5)",
                "&:hover": {
                  color: "black",
                  backgroundColor: "white",
                },
              }}
            >
              Download Files
            </Button>
            <Button
              onClick={handleExport}
              sx={{
                background: "blue",
                color: "white",
                fontSize: "14px",
                fontWeight: "bold",
                padding: "10px 20px",
                // mr: 4,
                borderRadius: "5px",
                boxShadow: "1px 1px 5px rgba(0, 0, 0, 0.5)",
                "&:hover": {
                  color: "black",
                  backgroundColor: "white",
                },
              }}
            >
              Export
            </Button>
            <Button
              onClick={() => handleClose()}
              sx={{
                background: "blue",
                color: "white",
                fontSize: "14px",
                fontWeight: "bold",
                padding: "10px 20px",
                // mr: 4,
                borderRadius: "5px",
                boxShadow: "1px 1px 5px rgba(0, 0, 0, 0.5)",
                "&:hover": {
                  color: "black",
                  backgroundColor: "white",
                },
              }}
            >
              Close
            </Button>
          </Box>
        </Box>
        <Dialog
          open={previewModalOpen}
          onClose={handleClosePreviewModal}
          maxWidth="xl"
          fullWidth
        >
          <DialogTitle
            sx={{
              alignItems: "center",
              display: "flex",
              justifyContent: "space-between",
              background: "#02690c",
              color: "white",
              padding: "16px",
            }}
          >
            <span style={{ flexGrow: 1, textAlign: "center" }}>
              {previewTitle ? `${previewTitle}` : "File Preview"}
            </span>

            <IconButton
              edge="end"
              color="inherit"
              onClick={handleClosePreviewModal}
              sx={{
                color: "white",
                "&:hover": {
                  backgroundColor: "#005300",
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <iframe
              src={previewUrl}
              width="100%"
              height="800px"
              title="File Preview"
              frameBorder="0"
            ></iframe>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClosePreviewModal}>Close</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Modal>
  );
}
